<tt-page>
    <tt-cust-grp2 [params]="params" (submit)="onSubmit($event)"></tt-cust-grp2>
</tt-page>
